import { render, staticRenderFns } from "./AllGlLevel2Table.vue?vue&type=template&id=f22e2c3c&scoped=true&"
import script from "./AllGlLevel2Table.vue?vue&type=script&lang=js&"
export * from "./AllGlLevel2Table.vue?vue&type=script&lang=js&"
import style0 from "./AllGlLevel2Table.vue?vue&type=style&index=0&id=f22e2c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22e2c3c",
  null
  
)

export default component.exports